export const LOCAL_STORAGE_NEW_GIFT = 'newGift';
export const LOCAL_STORAGE_NEW_GIFT_CLOSED = 'newGiftClosed';
